export const getEvaluationTaskLabel = (evaluationTask, brandId) => {
    if (evaluationTask.evalType === 'COURSE') {
        return getCourseLabel(evaluationTask, brandId);
    }

    return getTeacherLabel(evaluationTask);
}

export const getCourseLabel = (courseEvaluationTask, brandId='') => {
    const { courseCode, courseName, courseId } = courseEvaluationTask;
  
    // TODO: Remove brandsToOnlyShowCourseName once custom course display functionality is added
    const brandsToOnlyShowCourseName = ['qutc', 'kusurvey'];
    if (courseCode && courseName && !brandsToOnlyShowCourseName.includes(brandId)) {
      return `${courseCode}: ${courseName}`;
    }
  
    return courseName || courseCode || courseId;
};

export const getTeacherLabel = (teacherEvaluationTask) => {    
    if (teacherEvaluationTask.teacherName) {
        return teacherEvaluationTask.teacherName;
    }

    if (teacherEvaluationTask.teacherId) {
        return teacherEvaluationTask.teacherId;
    }

    return teacherEvaluationTask.batchId;
}
